// src/hooks/productTypes/useGetProductType.js
import { useQuery } from "@tanstack/react-query";
import { getProductType } from "../../api/apiProductTypes";
import i18next from "i18next";

const useGetProductType = (id) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ["productType", id, i18next.language],
        queryFn: () => getProductType(id),
        enabled: !!id,
    });

    const productType = data?.data || null;

    return { productType, isLoading, error };
};

export default useGetProductType;